import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SourceSelectionInjectionToken } from '../token';
import { ReviewSourceInfoMap, ReviewSources, SourceSelectionDependencies } from './types';

@Injectable({
  providedIn: 'root',
})
export class ReviewSourceSelectionService {
  reviewSources$: Observable<ReviewSources>;
  reviewSourcesWithURLs$: Observable<ReviewSources>;
  reviewSourceInfoMap$: Observable<ReviewSourceInfoMap>;
  showMyListing$: Observable<boolean>;

  constructor(@Inject(SourceSelectionInjectionToken) private readonly config: SourceSelectionDependencies) {
    this.reviewSources$ = this.config.reviewSources$;
    this.reviewSourcesWithURLs$ = this.config.reviewSourcesWithURLs$;
    this.reviewSourceInfoMap$ = this.config.reviewSourceInfoMap$;
    this.showMyListing$ = this.config.showMyListing$;
  }
}
